/* HYV — Back-in-stock requests (snippets/hyv-notify-me.liquid)

   Shows the request form only when the SELECTED variant is unavailable, and
   follows the swatch: pick a sold-out colour and the block appears naming that
   colour; pick one in stock and it disappears.

   Unlike the B2B gate, this one does NOT fail open. There, a network error must
   not stand between a buyer and the prices; here, the whole value of the
   interaction is that the address reaches us. Telling someone "we'll email you"
   when nothing was recorded is worse than telling them it failed. */
(function () {
  'use strict';
  var root = document.querySelector('[data-hyv-notify]');
  if (!root) return;

  var openBtn = root.querySelector('[data-hyv-notify-open]');
  var form = root.querySelector('[data-hyv-notify-form]');
  var msg = root.querySelector('[data-hyv-notify-msg]');
  var variantEl = root.querySelector('[data-hyv-notify-variant]');
  var endpoint = root.getAttribute('data-endpoint') || '';

  /** Variant data as Shopify prints it on the PDP, so availability is exact. */
  function variantMap() {
    var el = document.querySelector('[type="application/json"][data-product-json], script.product-json');
    if (el) { try { return JSON.parse(el.textContent).variants || []; } catch (e) {} }
    return [];
  }

  function currentVariantId() {
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return input ? parseInt(input.value, 10) : parseInt(root.getAttribute('data-variant-id'), 10);
  }

  function sync() {
    var id = currentVariantId();
    var variants = variantMap();
    var v = null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id === id) { v = variants[i]; break; }
    }

    // No variant JSON on the page (theme variation): fall back to the server's
    // opinion, which is correct on first paint and stale only after a swatch
    // change — better than guessing "available" and hiding the form.
    var soldOut = v ? v.available === false : root.hasAttribute('data-out-of-stock');
    root.hidden = !soldOut;
    if (!soldOut) { collapse(); return; }

    var title = v ? v.title : root.getAttribute('data-variant');
    if (variantEl && title) variantEl.textContent = title;
    root.setAttribute('data-variant', title || '');
    root.setAttribute('data-variant-id', String(id || ''));
  }

  function collapse() {
    if (form) form.hidden = true;
    if (openBtn) openBtn.hidden = false;
    if (msg) { msg.hidden = true; msg.className = 'hyv-notify__msg'; }
  }

  if (openBtn) openBtn.addEventListener('click', function () {
    openBtn.hidden = true;
    form.hidden = false;
    var input = form.querySelector('input[name=email]');
    if (input) input.focus();
  });

  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    var input = form.querySelector('input[name=email]');
    var email = (input.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      show('warn', 'That email doesn’t look right.');
      input.focus();
      return;
    }

    var btn = form.querySelector('.hyv-notify__submit');
    if (btn) { btn.disabled = true; btn.textContent = 'Saving…'; }

    var payload = {
      action: 'notify_me',
      email: email,
      product: root.getAttribute('data-product'),
      variant: root.getAttribute('data-variant'),
      variant_id: root.getAttribute('data-variant-id'),
      url: root.getAttribute('data-product-url'),
      submitted_at: new Date().toISOString()
    };

    var done = function (ok) {
      if (btn) { btn.disabled = false; btn.textContent = 'Notify me'; }
      if (ok) {
        form.hidden = true;
        if (openBtn) {
          openBtn.hidden = false;
          var label = openBtn.querySelector('[data-hyv-notify-label]');
          if (label) label.textContent = 'We’ll email you when it’s back';
          openBtn.disabled = true;
        }
        show('ok', 'Saved. We’ll email you the moment it’s back — nothing else.');
        msg.hidden = false;
      } else {
        show('warn', 'We couldn’t save that just now. Please message us and we’ll add you by hand.');
      }
    };

    if (!endpoint) { done(false); return; }
    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(payload),
      keepalive: true
    })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r; })
      .then(function () { done(true); })
      .catch(function () { done(false); });
  });

  function show(kind, text) {
    if (!msg) return;
    msg.className = 'hyv-notify__msg hyv-notify__msg--' + kind;
    msg.textContent = text;
    msg.hidden = false;
  }

  sync();
  document.addEventListener('variant:change', sync);
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'id') sync();
  }, true);
})();
